import './ColorPicker.scss';
import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';
import OverlayLayer from "../OverlayLayer/OverlayLayer";

interface ColorPickerCallbacks {
    onColorChange: (block_id: number, color: string) => void;
    onColorPickerClose: () => void;
}

export interface ColorPickerInstance {
    div: HTMLDivElement;
    show: (block_id: number) => void;
    hide: () => void;
    setColor: (color: string) => void;
    setPosition: (x: number, y: number) => void;
}

const TG_palette_new = {
    'col1': ['#7a1db4', '#9a3ee9', '#bb70ff', '#d8a2ee'],
    'col2': ['#4531c3', '#5847eb', '#7a7aff', '#9ea1ff'],
    'col3': ['#0d60cd', '#2c90e8', '#66b8ff', '#94cdff'],
    'col4': ['#039cb3', '#1bc3cf', '#6aebf4', '#99fcff'],
    'col5': ['#00c287', '#2ce8a3', '#5cffc3', '#8fffd4'],
    'col6': ['#1fb601', '#58e82c', '#82ff5c', '#b0ffa1'],
    'col7': ['#b0bd00', '#c8e82c', '#e4ff5c', '#ecff8e'],
    'col8': ['#b37700', '#e89c2c', '#ffbe5c', '#ffd991'],
    'col9': ['#c83403', '#e95a3a', '#ff7a5c', '#ffa676'],
    'col10': ['#b2001e', '#e3214e', '#ff6186', '#ff93a6'],
    'col11': ['#333333', '#999999', '#ffffff', '#616161']
}

export const ColorPicker = (callbacks: ColorPickerCallbacks) => {

    let div = document.createElement('div');
    let zIndex = 30000;
    let colors = Object.values(TG_palette_new).flat();
    let selectedColor = '#ffffff';
    let block_id: number | null = null;
    let overlay = OverlayLayer(
        'ColorPickerOverlay',
        {
            onClick: () => {
                console.log('ColorPickerOverlay onClick');
                hide();
            }
        },
        // zIndex - 1
        29999
    );

    div.style.zIndex = zIndex.toString();

    const show = (_block_id: number) => {
        console.log('ColorPicker show', _block_id, div);
        div.classList.add('sp-visible');
        block_id = _block_id;
        overlay.show();
        // document.addEventListener('click', eventHandlerOutsideClick);
    }

    const hide = () => {
        console.log('ColorPicker hide', div);
        div.classList.remove('sp-visible');
        overlay.hide();
        // document.removeEventListener('click', eventHandlerOutsideClick);
    }

    const setColor = (color: string) => {
        selectedColor = color;
        let input = div.querySelector('.sp-input') as HTMLInputElement;
        if (input) {
            input.value = color;
        }
    }

    const isColorValid = (color: string) => {
        return /^#[0-9A-F]{6}$/i.test(color);
    }

    const markValidationResult = (isValid: boolean) => {
        let input = div.querySelector('.sp-input') as HTMLInputElement;
        if (input) {
            if (isValid) {
                input.classList.remove('sp-input-error');
            } else {
                input.classList.add('sp-input-error');
            }
        }
    }

    div.classList.add('sp-container--telematics'); // FIXME: add support for this class in CSS
    div.innerHTML = `
    <div class="sp-title">Wybierz kolor</div>
    <div class="sp-palette-container">
        <div class="sp-palette sp-thumb">
                ` + colors.map((color, index) => {
        return `<div class="sp-color-item" data-color="${color}" style="background-color: ${color}"></div>`;
    }).join('') + `
        </div>
    </div>
    <div class="sp-footer">
        <div class="sp-input-container">
            <div>HEX</div>
            <input class="sp-input input" type="text" spellcheck="false" maxlength="7">
        </div>
        <div class="sp-button-container">
            <button class="sp-cancel btn-cancel">${get(_)('Cancel')}</button>
            <button class="sp-choose btn-choose">${get(_)('Apply')}</button>
        </div>
    </div>`;

    // Remove active class from all colors
    div.querySelectorAll('.sp-color-item').forEach((item) => {
        item.classList.remove('active');
    });

    // When user click on save button, hide color picker and call onColorChange callback
    let buttonSave = div.querySelector('.btn-choose');
    if (buttonSave) {
        buttonSave.addEventListener('click', () => {
            markValidationResult(isColorValid(selectedColor));
            if (!isColorValid(selectedColor)) {
                console.warn('Color is not valid', selectedColor);
            } else {
                hide();
                if (block_id !== null) {
                    callbacks.onColorChange(block_id, selectedColor);
                } else {
                    throw new Error('block_id is null');
                }
            }
        });
    }

    // When user click on cancel button, hide color picker
    let buttonCancel = div.querySelector('.btn-cancel');
    if (buttonCancel) {
        buttonCancel.addEventListener('click', () => {
            markValidationResult(isColorValid(selectedColor));
            hide();
            callbacks.onColorPickerClose();
        });
    }

    // When user click on color, set it as selected
    div.querySelectorAll('.sp-color-item').forEach((item) => {
        item.addEventListener('click', (e) => {
            div.querySelectorAll('.sp-color-item').forEach((item) => {
                item.classList.remove('active');
            });
            item.classList.add('active');
            let color = (e.target as HTMLElement).getAttribute('data-color');
            if (color) {
                selectedColor = color;
                let input = div.querySelector('.sp-input') as HTMLInputElement;
                if (input) {
                    input.value = color;
                }
                hide();
                if (block_id !== null) {
                    callbacks.onColorChange(block_id, selectedColor);
                } else {
                    throw new Error('block_id is null');
                }
            }
        });
    });


    // When user change color in input, set it as selected
    let input = div.querySelector('.sp-input') as HTMLInputElement;
    if (input) {
        input.addEventListener('keyup', (e) => {
            let color = (e.target as HTMLInputElement).value;
            markValidationResult(isColorValid(color));
            if (isColorValid(color)) {
                selectedColor = color;
                div.querySelectorAll('.sp-color-item').forEach((item) => {
                    item.classList.remove('active');
                });
            }
        });
    }


    return {
        div,
        show,
        hide,
        setColor,
        setPosition: (x: number, y: number) => {
            div.style.left = x + 'px';
            div.style.top = y + 'px';
        }
    }
}
